export default __webpack_public_path__ + "strongher-devices_tablet@2x.8c818d07.png";